import { Injectable } from '@angular/core';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { PhoneNumberFormat } from 'src/app/models/customer/phone-number-format';
import { PhoneNumberMask } from 'src/app/models/customer/phone-number-mask';
import { ToastControllerWrapperService } from '../toast-controller-wrapper/toast-controller-wrapper.service';

@Injectable({
  providedIn: 'root'
})
export class FormatService {

  constructor(
    public toasterWrapper: ToastControllerWrapperService,

  ) { }

  //REGION - PHONE NUMBER FORMAT

  validatePhoneNumberFormat(phoneNumberFormat) {
    //not allowed to have _'s in format because it's used as a placeholder - strip it out and notify the user
    if (phoneNumberFormat.indexOf(PhoneNumberMask.SHOWN_PLACEHOLDER_CHARACTER) !== -1) {
      console.log("'_' character detected in phone number format. Stripping it out.");
      this.toasterWrapper.presentErrorToast(
        'The "_" character was detected in phone number format [' + phoneNumberFormat + '] and is not allowed as it is reserved as a placeholder and will be removed. Please contact your system administrator.'
      );
      phoneNumberFormat = phoneNumberFormat.replace(new RegExp(PhoneNumberMask.SHOWN_PLACEHOLDER_CHARACTER, 'g'), '');
    }
    return phoneNumberFormat;
  }

  //ENDREGION - PHONE NUMBER FORMAT
}
